import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import moment from 'moment';

import { BoardHeaderStyled, BoardHeaderWrapper, HeaderTab, HeaderTabs, Label } from './ui/styles';
import { StyledModalListItem } from '../../components/StyledListItem';
import ContentBoardStyled from '../../components/ContentBoardStyled';
import useReportsForDealer from '../../api/useReportsForDealer';
import ItemLinkStyled from '../../components/ItemLinkStyled';
import NoItemsInList from '../../components/NoItemsInList';
import { ControlBarContext } from '../ControlBarContext';
import DateInput from '../Activity/components/DateInput';
import DateStyled from '../../components/DateStyled';
import Scrollable from '../../components/Scrollable';
import { formattedDate } from '../../utils/date';
import useDealer from '../../api/useDealer';

const BillingDealerReports = ({ getBreadCrumbs }) => {
  const { setBreadCrumbs } = useContext(ControlBarContext);
  const { hmsId } = useParams();
  const { dealer } = useDealer(hmsId);

  const [tabValue, setTabValue] = useState(0);
  const [selectedDate, setSelectedDate] = useState(moment());
  const handleTabChange = useCallback((_, tab) => setTabValue(tab), [setTabValue]);

  const { reports } = useReportsForDealer(hmsId, {
    reportDay: tabValue ? formattedDate(selectedDate, 'YYYY-MM-DD') : null,
    notes: ['Full Shoot']
  });

  useEffect(() => {
    dealer && setBreadCrumbs(getBreadCrumbs({ dealerName: dealer.name }));
  }, [getBreadCrumbs, dealer, setBreadCrumbs]);

  return (
    <ContentBoardStyled>
      <BoardHeaderWrapper>
        <BoardHeaderStyled>USER REPORTS</BoardHeaderStyled>
        <HeaderTabs value={tabValue} onChange={handleTabChange}>
          <HeaderTab label={'All time'} />
          <HeaderTab
            label={
              <DateInput
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                labelElement={<Label>{formattedDate(selectedDate)}</Label>}
              />
            }
          />
        </HeaderTabs>
      </BoardHeaderWrapper>

      <Scrollable maxHeight={`calc(100vh - 150px - 50px)`}>
        {reports?.items?.length ? (
          reports.items.map((report) => (
            <Fragment key={report.day}>
              <DateStyled>{formattedDate(report.day)}</DateStyled>
              {report.users.map((user) => (
                <ItemLinkStyled
                  to={`/billing/dealers/${hmsId}/${user.uuid}/${report.day}`}
                  key={`${hmsId}${user.uuid}${report.day}`}
                >
                  <StyledModalListItem name={user.displayName} />
                </ItemLinkStyled>
              ))}
            </Fragment>
          ))
        ) : (
          <NoItemsInList>No reports to show</NoItemsInList>
        )}
      </Scrollable>
    </ContentBoardStyled>
  );
};

export default BillingDealerReports;
